import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { PrimaryButton } from 'ia-react-core';
import { redirectTo } from 'omni-package-react-core';
import { StyledActionBar } from './PersonalInformationsConfirmationPageContent.styles';
import { PersonalInfosChangeData } from '../../../interfaces/PersonalInfosChangeData';
import ConfirmationSuccessSection from './ConfirmationSuccessSection';
import ConfirmationWarningSection from './ConfirmationWarningSection';

export interface PersonalInformationsConfirmationPageContentProps {
  changeData: PersonalInfosChangeData;
  returnPage: string;
}

const PersonalInformationsConfirmationPageContent: FC<PersonalInformationsConfirmationPageContentProps> = ({ changeData, returnPage }) => {
  const { t } = useTranslation('PersonalInformationsConfirmationPage');
  const navigate = useNavigate();

  return (
    <>
      <ConfirmationWarningSection allContracts={changeData?.unchangedContracts?.concat(changeData?.changedContracts)} />
      <ConfirmationSuccessSection changedContracts={changeData?.changedContracts} />
      <StyledActionBar flexButtons>
        <PrimaryButton onClick={() => { redirectTo(returnPage, navigate); }}>
          {t('closeButton')}
        </PrimaryButton>
      </StyledActionBar>
    </>
  );
};
export default PersonalInformationsConfirmationPageContent;
